import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import SectionHeading from '@/components/base/SectionHeading';

const accentMap = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function CategoryGrid() {
  return (
    <section className="border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <SectionHeading
          eyebrow="主题分类"
          title="按栏目找你想看的"
          description="六个常设栏目覆盖明星、综艺、影视、网红、网络热议与行业观察，内容按主题归位，不必在信息流里翻找。"
          action={
            <Link
              to="/topics"
              className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800"
            >
              浏览全部话题
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((item) => (
            <Link
              key={item.slug}
              to={`/topics?category=${item.slug}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-lg text-xl ${accentMap[item.accent]}`}
                >
                  <i className={item.icon} aria-hidden="true" />
                </span>
                <span className="text-xs text-foreground-600">{item.count} 篇</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                {item.name}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.description}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-700">
                进入栏目
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}